import { useState } from "react";

const industries = [
  {
    id: "01",
    title: "Ecommerce",
    desc: "Discover quality products at unbeatable prices. Shop smarter, faster, and safer with our trusted eCommerce platform.",
  },
  {
    id: "02",
    title: "Fintech",
    desc: "Gather information about your business, its structure, goals and policies.",
  },
  {
    id: "03",
    title: "Healthcare",
    desc: "We provide compassionate, advanced healthcare services to keep you and your family healthy. Your wellness is our priority.",
  },
  {
    id: "04",
    title: "Edutech",
    desc: "Unlock your potential with interactive courses, expert instructors, and personalized learning paths. Education made easy, anywhere, anytime.",
  },
  {
    id: "05",
    title: "Enterprise & Logistics",
    desc: "From supply chain management to last-mile delivery, we provide reliable, efficient, and innovative logistics solutions to drive your business forward.",
  },
  {
    id: "06",
    title: "Real Estate",
    desc: "Explore premium properties, get expert guidance, and make your next move with confidence. Whether buying, selling, or renting, we make real estate simple.",
  },
  {
    id: "07",
    title: "Travel & Hospitality",
    desc: "Discover unforgettable destinations, handpicked stays, and seamless travel experiences. Adventure, comfort, and memories await.",
  },
];

const Invotation = () => {
  const [active, setActive] = useState("01");
  const [hovered, setHovered] = useState(null);

  return (
    <div className=" w-screen bg-[#242124] mt-[10%]">
      <div className=" w-full bg-[#242124]  mt-[5%]  relative">
        <div className="hidden md:flex justify-center w-full px-20">
          <div className="w-[1440px] h-[953px]   ">
            <div className="flex justify-between items-start gap-12 mb-14">
              <div>
                <h1 className="leading-[1.05]">
                  <span className="block text-[#FFFFFF] text-[64px] font-clash font-light">
                    Innovative Thinking
                  </span>
                  <span className="block text-white text-[82px] text-nowrap font-clash font-medium ">
                    Proven Execution
                  </span>
                </h1>
              </div>

              <p className="w-[547px] h-[136px] text-[22px] font-aileron text-white leading-8">
                Our cross-functional teams combine strategic insight with
                technical excellence to build scalable digital solutions that
                solve real business challenges and drive measurable growth.
              </p>
              <div className=" absolute top-[600px] right-0 w-[620px] h-[458px]">
                <img
                  src="/assets/inv-background.svg"
                  className=" h-auto w-full object-cover"
                />
              </div>
            </div>

            <div className=" flex justify-start">
              <div className="flex justify-start gap-10 w-full ">
                {industries.map((item, index) => {
                  const isExpanded =
                    hovered !== null ? hovered === item.id : index === 0;

                  return (
                    <div
                      key={item.id}
                      onMouseEnter={() => setHovered(item.id)}
                      onMouseLeave={() => setHovered(null)}
                      className={`
                relative cursor-pointer
                rounded-2xl border border-white/10
                bg-gradient-to-b from-[#0f0f0f] to-[#1a1a1a]
                flex flex-col overflow-hidden

                transition-[width,padding] 
                duration-[1400ms] 
                ease-[cubic-bezier(0.16,1,0.3,1)]
                will-change-[width,padding]

                ${
                  isExpanded
                    ? "w-[360px] h-[517px] p-8"
                    : "w-[120px] h-[517px] p-4"
                }
              `}
                    >
                      {/* Number */}
                      <span
                        className={`
                  text-white italic font-medium
                  transition-all duration-[1000ms] delay-200
                  ${isExpanded ? "text-[64px] opacity-100" : "text-[24px] opacity-60"}
                `}
                      >
                        {item.id}.
                      </span>

                      <div
                        className={`
                  flex flex-col gap-2 mt-4
                  transition-all duration-[1100ms] delay-300
                  ${
                    isExpanded
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-4 pointer-events-none"
                  }
                `}
                      >
                        <h3 className="text-white text-[30px] font-medium">
                          {item.title}
                        </h3>

                        <p className="text-[#FFFFFFB2] text-[16px] leading-relaxed">
                          {item.desc}
                        </p>
                      </div>

                      {/* Collapsed Rotated Title */}
                      <div
                        className={`
                  absolute inset-0 flex items-center justify-center
                  transition-opacity duration-[900ms]
                  ${isExpanded ? "opacity-0 pointer-events-none" : "opacity-80"}
                `}
                      >
                        <span className="text-gray-300 text-sm tracking-wide rotate-90 whitespace-nowrap">
                          {item.title}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className=" md:hidden w-screen bg-[#242124] py-16">
          <div className="flex justify-center w-full">
            <div className="w-full max-w-[1440px] px-6">
              {/* Header */}
              <div className="flex flex-col gap-8 mb-12">
                <h1 className="leading-[1.05]">
                  <span className="block text-white text-[35px] font-light font-clash">
                    Innovative Thinking
                  </span>
                  <span className="block text-white text-[45px] font-medium font-clash">
                    Proven Execution
                  </span>
                </h1>

                <p className="text-white/70 text-[16px] leading-7 max-w-xl">
                  Our cross-functional teams combine strategic insight with
                  technical excellence to build scalable digital solutions that
                  solve real business challenges.
                </p>
              </div>

              {/* Cards Column */}
              <div className="flex flex-col gap-6">
                {industries.map((item, index) => {
                  // Determine which card is expanded
                  const isExpanded =
                    hovered !== null ? hovered === item.id : index === 0;

                  return (
                    <div
                      key={item.id}
                      onMouseEnter={() => setHovered(item.id)}
                      onMouseLeave={() => setHovered(null)}
                      className={`
          cursor-pointer transition-all duration-500 ease-in-out
          rounded-2xl border border-white/10
          bg-gradient-to-b from-[#0f0f0f] to-[#1a1a1a]
          overflow-hidden
          ${isExpanded ? "p-6 h-[240px]" : "p-5 h-[70px]"}
        `}
                    >
                      {/* Title Row */}
                      <div className="flex items-center gap-4">
                        <span
                          className={`text-white italic font-medium transition-all duration-500 ${
                            isExpanded ? "text-2xl" : "text-xl"
                          }`}
                        >
                          {item.id}.
                        </span>

                        <h3
                          className={`text-white font-clash transition-all duration-500 ${
                            isExpanded ? "text-lg" : "text-base"
                          }`}
                        >
                          {item.title}
                        </h3>
                      </div>

                      {/* Expand Content */}
                      <div
                        className={`transition-all duration-500 ease-in-out overflow-hidden ${
                          isExpanded
                            ? "opacity-100 mt-4 max-h-96"
                            : "opacity-0 mt-0 max-h-0"
                        }`}
                      >
                        <p className="text-white/70 text-sm leading-relaxed max-w-2xl">
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invotation;
